import { FC, SyntheticEvent, useCallback, useState } from 'react';
import { useSnapshot } from 'valtio';
import IssueOptions from '../components/IssueTableRow/IssueOptions';
import { closeExcludeIssueModal } from '../store-actions/issues-exclusions-store-actions';
import IssuesExclusionsStore from '../stores/issues-exclusions-store';
import IssuesStore from '../../active-issues/stores/issues-store';
import { Issue } from '../types/issues-types';
import { setMenuIssueId } from '../../active-issues/actions/active-issues-actions';

const IssueOptionsContainer: FC<
  React.PropsWithChildren<IssueOptionsContainerProps>
> = ({ issue }) => {
  const {
    policyDisableModal,
    isActiveJiraConnection,
    isActiveSlackConnection,
  } = useSnapshot(IssuesStore);
  const { exclusionsCategories } = useSnapshot(IssuesExclusionsStore);

  const [open, setOpen] = useState(false);

  const handleOpenMenu = useCallback((e: SyntheticEvent) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuIssueId(null);
    setOpen(false);
  }, []);

  return (
    <IssueOptions
      policyDisableModal={policyDisableModal}
      withOptions={false}
      exclusionsCategories={exclusionsCategories}
      handleExcludeAlert={closeExcludeIssueModal}
      isActiveJiraConnection={isActiveJiraConnection}
      isActiveSlackConnection={isActiveSlackConnection}
      isPRAvailable={issue.isPRAvailable}
      fixIssue={issue.fixIssue}
      issueId={issue.issueId}
      handleOpenMenu={handleOpenMenu}
      handleCloseMenu={handleCloseMenu}
      open={open}
      isFixAvailable={issue.fixes ? true : false}
      categoryId={issue.categoryId}
      policyId={issue.policyId}
    />
  );
};

export interface IssueOptionsContainerProps {
  issue: Issue;
}

export default IssueOptionsContainer;
